import request from '../../utils/request';
import { Result } from '../../models/general';
import type {
    MovementTypeView, MovementTypeInput,
    ExitReasonView, ExitReasonInput,
    OnboardingTaskTypeView, OnboardingTaskTypeInput,
    OffboardingTaskTypeView, OffboardingTaskTypeInput,
    MovementTaskTypeView, MovementTaskTypeInput,
} from '../../models/employee';

// ── Movement Types ──────────────────────────────────────────────

export async function getMovementTypes(): Promise<Result<MovementTypeView[]>> {
    const response = await request.get<Result<MovementTypeView[]>>('LifecycleSettings/GetMovementTypes');
    return response.data;
}

export async function addMovementType(input: MovementTypeInput): Promise<Result<MovementTypeView>> {
    const response = await request.post<Result<MovementTypeView>>('LifecycleSettings/AddMovementType', input);
    return response.data;
}

export async function updateMovementType(id: number, input: MovementTypeInput): Promise<Result<MovementTypeView>> {
    const response = await request.put<Result<MovementTypeView>>(`LifecycleSettings/UpdateMovementType/${id}`, input);
    return response.data;
}

export async function deleteMovementType(id: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`LifecycleSettings/DeleteMovementType/${id}`);
    return response.data;
}

// ── Exit Reasons ────────────────────────────────────────────────

export async function getExitReasons(): Promise<Result<ExitReasonView[]>> {
    const response = await request.get<Result<ExitReasonView[]>>('LifecycleSettings/GetExitReasons');
    return response.data;
}

export async function addExitReason(input: ExitReasonInput): Promise<Result<ExitReasonView>> {
    const response = await request.post<Result<ExitReasonView>>('LifecycleSettings/AddExitReason', input);
    return response.data;
}

export async function updateExitReason(id: number, input: ExitReasonInput): Promise<Result<ExitReasonView>> {
    const response = await request.put<Result<ExitReasonView>>(`LifecycleSettings/UpdateExitReason/${id}`, input);
    return response.data;
}

export async function deleteExitReason(id: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`LifecycleSettings/DeleteExitReason/${id}`);
    return response.data;
}

// ── Onboarding Task Types ───────────────────────────────────────

export async function getOnboardingTaskTypes(): Promise<Result<OnboardingTaskTypeView[]>> {
    const response = await request.get<Result<OnboardingTaskTypeView[]>>('LifecycleSettings/GetOnboardingTaskTypes');
    return response.data;
}

export async function addOnboardingTaskType(input: OnboardingTaskTypeInput): Promise<Result<OnboardingTaskTypeView>> {
    const response = await request.post<Result<OnboardingTaskTypeView>>('LifecycleSettings/AddOnboardingTaskType', input);
    return response.data;
}

export async function updateOnboardingTaskType(id: number, input: OnboardingTaskTypeInput): Promise<Result<OnboardingTaskTypeView>> {
    const response = await request.put<Result<OnboardingTaskTypeView>>(`LifecycleSettings/UpdateOnboardingTaskType/${id}`, input);
    return response.data;
}

export async function deleteOnboardingTaskType(id: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`LifecycleSettings/DeleteOnboardingTaskType/${id}`);
    return response.data;
}

// ── Offboarding Task Types ──────────────────────────────────────

export async function getOffboardingTaskTypes(): Promise<Result<OffboardingTaskTypeView[]>> {
    const response = await request.get<Result<OffboardingTaskTypeView[]>>('LifecycleSettings/GetOffboardingTaskTypes');
    return response.data;
}

export async function addOffboardingTaskType(input: OffboardingTaskTypeInput): Promise<Result<OffboardingTaskTypeView>> {
    const response = await request.post<Result<OffboardingTaskTypeView>>('LifecycleSettings/AddOffboardingTaskType', input);
    return response.data;
}

export async function updateOffboardingTaskType(id: number, input: OffboardingTaskTypeInput): Promise<Result<OffboardingTaskTypeView>> {
    const response = await request.put<Result<OffboardingTaskTypeView>>(`LifecycleSettings/UpdateOffboardingTaskType/${id}`, input);
    return response.data;
}

export async function deleteOffboardingTaskType(id: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`LifecycleSettings/DeleteOffboardingTaskType/${id}`);
    return response.data;
}

// ── Movement Task Types ─────────────────────────────────────────

export async function getMovementTaskTypes(): Promise<Result<MovementTaskTypeView[]>> {
    const response = await request.get<Result<MovementTaskTypeView[]>>('LifecycleSettings/GetMovementTaskTypes');
    return response.data;
}

export async function addMovementTaskType(input: MovementTaskTypeInput): Promise<Result<MovementTaskTypeView>> {
    const response = await request.post<Result<MovementTaskTypeView>>('LifecycleSettings/AddMovementTaskType', input);
    return response.data;
}

export async function updateMovementTaskType(id: number, input: MovementTaskTypeInput): Promise<Result<MovementTaskTypeView>> {
    const response = await request.put<Result<MovementTaskTypeView>>(`LifecycleSettings/UpdateMovementTaskType/${id}`, input);
    return response.data;
}

export async function deleteMovementTaskType(id: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`LifecycleSettings/DeleteMovementTaskType/${id}`);
    return response.data;
}
